import React, { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';

const Address = () => {
  document.title = 'Profile Settings ';

  // Dynamic address data
  const addresses = [
    {
      id: 1,
      title: 'Address',
      type: 'Office',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
      company: 'Test Company LLC',
      trn: '123455678797978',
    },
    {
      id: 2,
      title: 'Address',
      type: 'Home',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
    },
    {
      id: 3,
      title: 'Address',
      type: 'Office',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
      company: 'Test Company LLC',
      trn: '123455678797978',
    },
    {
      id: 4,
      title: 'Address',
      type: 'Office',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
      company: 'Test Company LLC',
      trn: '123455678797978',
    },
    {
      id: 5,
      title: 'Address',
      type: 'Office',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
      company: 'Test Company LLC',
      trn: '123455678797978',
    },
    {
      id: 6,
      title: 'Address',
      type: 'Office',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
      company: 'Test Company LLC',
      trn: '123455678797978',
    },
    {
      id: 7,
      title: 'Address',
      type: 'Office',
      name: 'Abdul Bari',
      address:
        'B16 Flat No 203 7CR7+4F8 - Al Qusais Industrial Area - Al Qusais Industrial Area 5 - Dubai - United Arab Emirates',
      mobile: '0565765550',
      company: 'Test Company LLC',
      trn: '123455678797978',
    },
  ];

  // Track visibility for each address
  const [visibleAddresses, setVisibleAddresses] = useState({});

  const toggleVisibility = (id) => {
    setVisibleAddresses((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const contentStyle = (isVisible) => ({
    maxHeight: isVisible ? 'none' : '160px',
    overflow: 'hidden',
    paddingBottom: '35px',
    transition: 'max-height 0.3s ease-in-out',
  });

  return (
    <>
      <Row>
        {addresses.map((address) => (
          <Col md={4} className="mb-3" key={address.id}>
            <div className="d-flex border rounded-3 flex-column p-3 h-auto fs-14 position-relative">
              <p className="d-flex align-items-center gap-2 fs-15 border-bottom pb-3">
                <span className="avatar-xxs">
                  <i
                    className={`avatar-title rounded bg-success-subtle text-dark fs-16 material-shadow rounded-circle lh-1 ${
                      address.type === 'Office'
                        ? 'ri-building-2-line'
                        : 'mdi mdi-home-variant-outline'
                    }`}
                  ></i>
                </span>
                <strong>
                  {address.title} - {address.id}
                </strong>
                <span className="fs-11 text-muted">({address.type})</span>
              </p>
              <div style={contentStyle(visibleAddresses[address.id])}>
                <p className="mb-2">
                  <span className="fs-11 text-muted d-block">Name</span>
                  {address.name}
                </p>
                <p className="mb-2">
                  <span className="fs-11 text-muted d-block">Address</span>
                  {address.address}
                </p>
                {address.mobile && (
                  <p className="mb-2">
                    <span className="fs-11 text-muted d-block">Mobile No.</span>
                    {address.mobile}
                  </p>
                )}
                {address.company && (
                  <p className="mb-2">
                    <span className="fs-11 text-muted d-block">
                      Company Name
                    </span>
                    {address.company}
                  </p>
                )}
                {address.trn && (
                  <p className="mb-0">
                    <span className="fs-11 text-muted d-block">TRN No.</span>
                    {address.trn}
                  </p>
                )}
              </div>
              <Button
                color="link"
                className="p-3 position-absolute bottom-0 start-0 w-100 bg-gradient fs-12 text-decoration-underline"
                onClick={() => toggleVisibility(address.id)}
                style={{ backdropFilter: 'blur(4px)' }}
              >
                {visibleAddresses[address.id] ? 'Hide' : 'View'}
              </Button>
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Address;
